import React from 'react'
import { includes, isNil, replace, forEachObjIndexed } from 'ramda'
import { validSteps } from './index'

export const validate = (intl, step) => (formData, errors) => {
  if(step === validSteps.languages) {
    if (errors.motherTongue && isNil(formData.motherTongue)) {
      errors.motherTongue.addError(intl.formatMessage({id: 'component.specialistDetails.error.motherTongue'}))
    }

    if (errors.languageKnowledges && formData.languageKnowledges && formData.languageKnowledges.length === 0) {
      errors.languageKnowledges.addError(intl.formatMessage({id: 'component.specialistDetails.error.languageKnowledges'}))
    }

    if (errors.languageKnowledges && formData.languageKnowledges && formData.languageKnowledges.length >  0) {
      forEachObjIndexed(
        (entry, index) => {
          const errObject = errors.languageKnowledges[index]
          if(isNil(entry.sourceLanguage)) {
            errObject.sourceLanguage.addError(intl.formatMessage({id: 'component.specialistDetails.error.sourceLanguage'}))
          }
          if(isNil(entry.workArea)) {
            errObject.workArea.addError(intl.formatMessage({id: 'component.specialistDetails.error.workArea'}))
          }
        },
        formData.languageKnowledges
      )
    }

  }
  return errors
}
export const RequiredStatus = ({required}) => required ?
  <i className="zmdi zmdi-check-circle field-info font-weight-bold text-success"/> : null

export const FieldInfo = ({id: rjfsId, required}) => {
  const id = replace(/_[0-9]+_/, '_', rjfsId.slice(5))
  return !required && !includes(id, ['email', 'emailVerified', 'vatIdStatus', 'languageKnowledges', 'stripeAccountId', 'descriptionOfTerms'] )? <em> – optional </em> : null
}
export const TitleField = (props) => {
  const {id, title, required} = props
  return <legend id={id} className="no-danger">
    <span>{title}</span> {id ? <FieldInfo id={id.slice(0, -7)}/> : null} <RequiredStatus required={required}/>
  </legend>
}
export const FieldTemplate = (props) => {
  const {id, classNames, label, help, description, children, required, displayLabel, disabled } = props
  return (
    <div className={classNames}>
      {displayLabel ?
        <label htmlFor={id} className="no-danger">
          {label}
          <FieldInfo id={id} required={required || disabled}/>
          <RequiredStatus required={required}/>
        </label> :
        null
      }
      {displayLabel ? description : null}
      {children}
      {help}
    </div>
  )
}



// WEBPACK FOOTER //
// ./Linkgua/components/SpecialistDetails/formSpecialisation.js